export default {
  message: {
    loading: "加載中",
    submit: "提交",
    invoiceAndPost: "發票和郵寄信息",
    productAndService: "產品和服務",
    payAliAccount: "支付帳戶",
    success: "操作成功",
    year: "年",
    day: "日",
    person: "人",
    errorTip: "錯誤提示",
    term: "《通用隱私政策》",
    salesTerm: "《銷售服務合同》",
    supplementTerm: "《軟件服務合同》",
    serviceContract: "《服務合同》",
    saleTip: "請聯系銷售下單",
    auth: {
      name: "去認證",
      none: "您還未進行企業主體認證，為保障您的合法權，請",
      noneAli: "您還未進行企業主體認證",
      toVertify: "立即認證",
      pass: "企業認證已通過",
      pending: "企業認證審核中，您的認證信息正在審核中，請稍後查看",
      refuse: "企业认证不通过",
      confirm: "請確認",
      noVerify: "您還未進行企業主體認證，請先提交",
      verifyToPC: "您還未進行企業主體認證，請用PC提交企業主體認證",
      certification: "企業認證",
      tarilPass: "您的企業主體認證初審通過，請進行",
      nextVertify: "下一步认证"
    },
    activate: {
      tips: "您還有未激活訂單",
      action: "去激活"
    },
    execute: {
      tips: "您還有未執行合同",
      action: "去執行"
    },
    complete: {
      tips: "您還有待支付訂單",
      action: "去完成"
    },
    back: "返回上一步",
    backOrder: "返回訂單列表"
  },
  component: {
    upload: "點擊上傳"
  },
  sideBar: {
    site: "OKKI 商城",
    home: "首頁",
    buy: "我要購買",
    order: "我的訂單",
    voucher: "我的優惠券"
  },
  home: {
    title: "我的產品",
    expiration: "當前訂單有效期",
    latest_expiration: "最晚到期時間",
    empty: "您當前還未購買任何產品",
    buy: "立即購買",
    detail: "查看明細",
  },
  store: {
    append: "追加",
    renew: "續約",
    upgrade: "升級",
    buy: "購買",
    to: "至",
    choice: "請選擇",
    selected: "已選擇",
    product: "項產品",
    total: "合計",
    free: "免費升級",
    settle: "去結算",
    error: ["請先選擇產品", "無法購買，請刷新頁面", "請輸入廣告預存費"],
    recommend: {
      code: "推薦碼",
      tips: "請輸入推薦碼",
      submit: "驗證",
      message: {
        error: ["推薦碼為空", "請先驗證邀請碼"],
        success: "推薦碼驗證成功"
      }
    },
    productAndService: "項產品和服務",
    agree: "您是否同意接受",
    and: "和",
    agreeText: "并愿意接收来自xiaoman.cn或okki.com的服务邮件",
    submit: "提交訂單",
    tip: "提示",
    warnTips: [
      "您將要",
      "的產品與當前的產品在功能、",
      "追加賬號價格",
      "方面存在較大差异",
      "新的產品版本將不再提供訂單、報價單、審批等產品功能，",
      "同時與之相關的數據也將不再保留。",
      "請您務必瞭解相關內容，如需瞭解更多，請訪問",
      "產品功能介紹"
    ],
    warnAgree: "已瞭解，去結算",
    googleAnvance: "（到賬廣告費，不含稅）",
    storeCloseTip: "小滿商城升級維護中，預計完成時間2021年1月4號。",
    noProductTip:"您當前沒有可新簽、續約、追加、陞級的產品"
  },
  order: {
    unlimited: "不限",
    history: "歷史訂單",
    unpaid: "未完成訂單",
    number: "Alibaba訂單",
    product: "產品和服務",
    paidTime: "付款時間",
    amount: ["實付金額", "應付金額"],
    paidAmount: "已支付",
    discountAmount: "優惠金額",
    totalAmount: "總計金額",
    pending: "待支付金額",
    paid: "已支付訂單",
    complete: "已完成訂單",
    auth: "企業認證後可激活訂單",
    post: "申請發票後可激活訂單",
    goPost: "去申請",
    payWay: "支付方式",
    mobile: "移動支付",
    zhifubao: "支付寶支付",
    alibaba: "阿里巴巴",
    alibabaShop: "國際站店",
    union: "轉賬付款",
    unionDollar: "美元付款",
    dollarTips: "請注意：轉賬手續費由您承擔",
    alibabaLogin: "登錄",
    alibabaPay: "阿裏巴巴賣家後臺支付",
    mobileTitle: "本次支付金額",
    mobileTotal: "全額支付",
    refreshCode: "刷新二維碼",
    mobileTips: "金額1000-39400範圍",
    company: "公司名",
    summary: "簡要",
    cancel: "取消訂單",
    activate: "激活訂單",
    subTotal: "小計",
    originAmount: "原價",
    share: "點擊右上角，轉發給客戶",
    authError: "您還未提交企業認證，不可激活訂單",
    postError: "您還未提交發票申請，不可激活訂單",
    activateError: "未知錯誤！不可激活訂單，請聯繫相關人員",
    activateSuccess: "激活訂單成功",
    download: ["下載合同", "下載待付款證明", "下載發票"],
    loading: "訂單提交",
    signPayComfirm: "簽署代付款證明後可激活訂單",
    signContract: "簽署合同後可激活訂單",
    overseaSignPayComfirm: "订单暂不可用，请联系销售经理上传代付款证明",
    overseaSignContract: "订单暂不可用，请联系销售经理上传合同",
    sign: "去簽署",
    orderInfoNone: "付款水單信息不完整，請等待系統更新"
  },
  product: {
    name: "產品",
    new: "新簽",
    renew: "續約",
    append: "追加",
    upgrade: "升級",
    activate: "激活",
    type: "類型",
    year: "年限",
    upgradeTo: "升級至",
    upgradeRenewTo: "升級和續約至",
    upgradeContract: "升級合同",
    upgradeContractTips: "默認升級所有可升級的訂單/合同",
    upgradeRenewContractTips: "續約2年標準方案（10賬號，1024GB空間，20萬封EDM）",
    oriDate: "原產品時間",
    siteName: "Shops站點",
  },
  service: {
    account: "賬號",
    purchased: "已購",
    used: "已用",
    available: "可用",
    to: "至",
    type: "類型",
    space: "空間",
    standard: "標配",
    extra: "額外購買",
    append: "追加",
    per: "份",
    maxAccount: "該方案最大賬號數：",
    maxTotalBuy: "當前合計已購買：",
    extraCount: "您還可增購：",
    okkiBaseApi: "追加OKKI-API標準接口：",
    okkiBaseApiCallCount: "追加OKKI-API接口調用次數：",
    okkiBaseApiOption1: "是",
    okkiBaseApiOption2: "否",
    okkiBaseApiYearCallCount: "每份含接口調用次數：300000次/年",
    okkiBaseApiTip: "（不限次數）"
  },
  union: {
    name: "戶名",
    account: "賬戶",
    bank: "開戶行",
    remark: "交易備註",
    amount: "匯款金額",
    payInfo: "完成轉賬後，請提供您的付款賬號信息",
    payer: "付款人",
    payerPlaceholder: "請填寫完整的開戶名",
    payAccount: "付款賬號",
    payAccountPlaceholder: "請填寫付款賬號",
    amountList: "上傳水單",
    tips: "您的付款賬號信息已提交",
    tipsInfo: "轉賬付款到賬週期一般為1~3個工作日，請耐心等待。如有問題，請聯繫",
    payerError: "請填寫付款人",
    payAccountError: "請填寫付款賬號",
    amountListError: "請上傳水單"
  },
  invoice: {
    tips: [
      "請確認發票信息，一旦開具將無法修改，開票金額不包括優惠/抵扣部分",
      "我司依法開具發票，請您按照稅法規定使用發票"
    ],
    notice: "新稅率公告",
    name: "發票信息",
    special: "增值稅專用發票",
    general: "電子普通發票",
    formal: "形式發票",
    type: "發票類型",
    status: "發票狀態",
    company: "企業名稱",
    taxpayer: "商業登記號",
    address: "註冊地址",
    tel: "註冊電話",
    bank: "開戶銀行",
    bankAccount: "銀行賬號",
    error: "請完善發票信息",
    letter: "一般納稅人認定通知書",
    download: "下載發票",
    reapply: "重新申請",
    message: {
      company: "請輸入單位名稱",
      bankAccount: "請輸入銀行賬號",
      bank: "請輸入開戶銀行",
      address: "請輸入註冊地址",
      tel: "請輸入註冊電話",
      taxpayer: "請輸入商業登記號",
      letter: "請上傳一般納稅人認定通知書"
    }
  },
  post: {
    name: "郵寄信息",
    contact: "收件人",
    mobile: "聯繫電話",
    code: "郵政快递",
    area: "所在地區",
    address: "詳細地址",
    error: "請完善郵寄信息",
    message: {
      contact: "請輸入收件人",
      mobile: "請輸入聯繫電話",
      area: "請選擇所在地區",
      address: "請輸入詳細地址"
    }
  },
  voucher: {
    name: "代金券",
    tips: "代金券不設找贖",
    agency: "代理商優惠券",
    discount: "折",
    limit: "使用限制",
    expiration: "有效期至",
    source: "來源",
    denomination: "优惠優惠",
    status: "狀態"
  },
  mainlandAuth: {
    step1: "法人信息",
    step2: "企業信息",
    step3: "信息審核",
    step4: "完成",
    authVertify1: "您即將打開第三方平台進行驗證，請根據頁面提示進行操作驗證：",
    authVertify2: "若沒自動打開，請點擊",
    authVertify3: "。若您已完成請點擊",
    authVertify4: "去認證",
    refresh: "刷新狀態",
    approving: "您的信息正在審核中，請稍後查看",
    approveVertify1: "您的信息",
    approveVertify2: "初審通過",
    approveVertify3: "請點擊",
    approveVertify4: "若您已完成提交請點擊",
    approveVertify5: "審核不通過",
    approveVertify6: "刷新狀態",
    approveVertify7: "重新提交",
    approveVertify9: "完成下一步信息提交",

    description1: "根據2019年4月修訂的《",
    description2: "電子簽名法",
    description3:
      "》第十三條和第二十條要求，您需要完成企業認證後方能進行有效的電子合同簽署",
    description4: "認證服務由",
    description5: "深圳法大大網絡科技有限公司",
    description6: "提供",
    description7: "認證和使用過程受 《",
    description8: "法大大使用協議",
    description9: "》、《",
    description10: "法大大隱私政策",
    description11: "》及中國相關法律約束和保障"
  },
  auth: {
    step1: "提交認證信息",
    step2: "信息審核",
    step3: "完成",
    companyName: "認證公司名",
    translatedName: "公司譯名",
    creditCode: "統一社會信用代碼",
    license: "營業執照(蓋公章)",
    licenseTips:
      "營業執照不可塗改，可以備註“用於合同簽署”等描述，其他備註均不通過審核。 ",
    signature: "自動簽章",
    read: "我已閱讀",
    grant: "《授權使用電子簽章委託書》",
    agree: "並同意委託",
    grantContent: [
      "為了委託方在受託方運營的網站（網址為:www.xiaoman.cn）上便利地簽署有關電子文件，委託方給予受託方如下代理權限並將在受託方網站進行如下業務：",
      "一、授權受託方提交相關材料向CA機構申請頒發數字證書（以下簡稱CA證書）；",
      "二、在受託方網站使用自己的CA證書進行電子文件自動簽署，簽署的文件範圍僅限於委託方付款成功的在線訂單所涉及的所有應簽署的電子文件。 ",
      "本委託書有效期限為10年；自雙方簽字（或蓋章）之日起生效。 "
    ],
    mobile: "綁定手機號",
    code: "圖形驗證碼",
    sms: "短信驗證碼",
    getSms: "獲取驗證碼",
    close: "關閉",
    submit: "提交",
    verify: "驗證",
    message: {
      companyName: "請輸入公司名",
      translatedName: "請輸入公司譯名",
      transNameError: "認證公司名或公司譯名其中壹個必須是中文",
      creditCode: "請輸入統一社會信用代碼",
      license: "請上傳營業執照",
      mobile: "請輸入正確的手機號",
      imgCode: "請輸入圖形驗證碼",
      mobileCode: "請輸入短信驗證碼",
      errCreditCode: "請輸入合法的統一社會信用碼"
    },
    pending: "後台審核中...",
    success: "恭喜您！已完成企業認證",
    ci63ee: "請按住滑塊，拖動到最右邊",
    caf5sf: "驗證通過",
    chok49: "網絡不給力，請",
    wgmi3n: "點擊刷新",
    cybpop: "出錯了，點擊",
    f1v4y4: "再來一次",
    cgoyus: "加載中...",
    ith53j: "請向右滑動驗證",
    pono45: "驗證通過",
    y2vznd: "非常抱歉，這齣錯了..."
  },
  fadada: {
    success: "信息提交成功",
    successTip: "請在PC進行下一步操作",
    fail: "信息提交失敗",
    failTip1: "請",
    failTip2: "刷新",
    failTip3: "PC頁面，再次點擊",
    failTip4: "去認證",
    failTip5: "操作"
  },
  appointment: {
    listTitle: "OKKI 新簽客戶預約實施",
    listDesc1:
      "本預約系統針對新簽客戶預約實施時間，請根據您的時間進行選擇並提交。",
    listDesc2: "實施前10分鐘，實施顧問將與您聯系。",
    listDesc3: "如有疑問請致電400-0666-517。",
    restCount: "剩余：",
    applyTitle: "預留信息",
    applyTip:
      "您已選擇 {time}進行系統實施，請完善相關信息並提交。實施前10分鐘，實施顧問將與您聯系，請保持電話暢通。",
    company: "公司名",
    contact: "聯系人",
    contactPlaceholder: "請填寫聯系人",
    mobile: "聯系電話",
    mobilePlaceholder: "請填寫聯系電話",
    mobileValidate: "請輸入正確的聯系電話",
    verifyCode: "驗證碼",
    sendVerifyCode: "發送驗證碼",
    wechat: "微信號",
    wechatOptions: "聯系手機可添加微信",
    wechatRules: "請輸入微信號",
    dingding: "釘釘號",
    dingdingOptions: "聯系手機可添加釘釘",
    dingdingRules: "請輸入釘釘號",
    sure: "確定",
    cancel: "取消",
    cancelTitle: "是否保留預約",
    cancelTip1: "因實施資源有限，請勿頻繁操作取消。",
    cancelTip2: "是否保留{time}進行系統實施的預約？",
    cancelBtn1: "取消預約",
    cancelBtn2: "保留預約",
    cancelSuccess: "取消成功",
    applySuccessTip1:
      "您已預約 {time} 進行系統實施，實施前10分鐘，實施顧問將與您聯系，請保持電話暢通。",
    applySuccessTip2: "您已完成實施流程，預約培訓課程請點擊培訓預約",
    applyAccount: "本預約系統僅限主賬號進行操作，請聯系主賬號進行預約。",
    applyImplete: "預約培訓",
    demandDes: "您正在向小滿科技預約在沙盒環境下為用戶提供小滿SaaS軟件的遠程實施服務。您理解並知悉，為提高遠程實施服務的效率，小滿科技需要",
    demandDesB: "采集用戶小滿SaaS軟件中的配置信息（如客戶分類分組、客戶標簽、客戶字段設置等，以下簡稱“配置信息”。配置信息不包括用戶錄入小滿SaaS軟件生產環境中的訂單信息、買家信息等商業信息）以便提前準備相應的實施方案。",
    demandDesSecondB: "您作為用戶小滿主賬戶的管理者點擊“下一步”並成功預約遠程實施服務時間的，即表明用戶授權同意小滿科技采集並使用該配置信息；您不同意小滿科技采集或使用該配置信息的，請不要在下一步預約遠程實施服務的時間。",
    demandComponyName: "公司名",
    demandNext: "下一步",
    appointmentLimit: "累計取消{total_cancel_count}次，凍結{forbid_appointment_hour}小時內不能申請預約。"
  }
};
